export enum DashboardPage {
  Overview = 'OVERVIEW',
  Visitations = 'VISITATIONS',
}
